"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictureMode = void 0;
var PictureMode;
(function (PictureMode) {
    PictureMode["FIT_TO_HEIGHT"] = "FIT_TO_HEIGHT";
    PictureMode["FIT_TO_WIDTH"] = "FIT_TO_WIDTH";
    PictureMode["COVER"] = "COVER";
    PictureMode["CONTAIN"] = "CONTAIN";
})(PictureMode = exports.PictureMode || (exports.PictureMode = {}));
//# sourceMappingURL=picture.types.js.map